import React from 'react';
import { TenantLeaseInfo } from 'graphql-query-contracts';
import { Flex } from 'components';
import { useTranslation } from 'react-i18next';
import { ViewTenantLeaseItem } from './ViewTenantLeaseItem';

export type ViewTenantLeasesProps = {
  tenantLeases: TenantLeaseInfo[];
};

export const ViewTenantLeases = ({ tenantLeases }: ViewTenantLeasesProps) => {
  const { t } = useTranslation();

  const floorNamesSet = new Set<string>();

  tenantLeases.forEach(lease => {
    lease.suite?.floors?.forEach(floor => {
      if (floor?.name) {
        floorNamesSet.add(floor.name);
      }
    });
  });

  const floorNames = Array.from(floorNamesSet).join(', ') || '-';

  const renderTenantLeases = () => {
    if (!tenantLeases.length) {
      return '-';
    }

    return tenantLeases.map(lease => {
      const key = `${lease.tenantId}-${lease.suiteId}-${lease.leaseId}-${lease.source?.sourceType}-${lease.source?.sourceRelationshipType}-${lease.source?.sourceRelationshipId}`;

      return <ViewTenantLeaseItem key={key} lease={lease} />;
    });
  };

  return (
    <Flex direction="column" gap={3}>
      <Flex direction="column" className="w-1/3" gap={3}>
        <b>
          {t(
            'web.admin.channel.settings.tenantManagement.tenant.details.viewLeases.floor'
          )}{' '}
        </b>
        <span data-test="floor-names">{floorNames}</span>
      </Flex>
      <Flex direction="column" gap={3}>
        <b>
          {t(
            'web.admin.channel.settings.tenantManagement.tenant.details.viewLeases.suite'
          )}
        </b>
        <Flex direction="column" gap={3}>
          {renderTenantLeases()}
        </Flex>
      </Flex>
    </Flex>
  );
};
